export default __webpack_public_path__ + "static/assets/appointment_successful.5abae8bc.png";